//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: () => ({
        type:''
    }),
    methods: {
       //认证信息
       changeInfo(leix){
           if(this.type==2){
               this.$router.push({
                   path:'/person/ownerChangeInfo?type='+leix
               })
           }
           if(this.type==3){
               this.$router.push({
                   path:'/person/providerChangeInfo?type='+leix
               })
           }
       },
    },
    mounted() {
       this.type= this.$route.query.type;
    }
}
